export default __webpack_public_path__ + "static/media/korecki-logo-dark.264e8d5f.png";